import PropTypes from 'prop-types';
import React, { Component } from 'react';
import i18next from "../../i18n";
import { hideModalDialog, showModalDialog } from '../ModalDialog';
import { Svg } from '../Svg';
import { CommentForm } from './CommentForm';
import { removeCommentAction } from './CommentsActions';
import * as constants from '../../constants';
import { downloadFile } from '../document/DocumentHelpers';
import { decodeHTMLEntities } from '../helpers/HelperFunctions';
import { RichTextEditor } from './RichTextEditor';

export class Comment extends Component {
    static contextType = constants.UserContext;
    static propTypes = {
        handleChangeComents: PropTypes.func.isRequired,
        parentCommentId: PropTypes.string,
        documentId: PropTypes.string,
        handleDeliteComent: PropTypes.func,
        handleChangeComent: PropTypes.func,
        statuses: PropTypes.array,
        comment: PropTypes.object.isRequired,
        nesting: PropTypes.number
    };
    constructor(props) {
        super(props);
        this.state = { show: false };
        Object.keys(this.props.comment).map((key) =>
            this.state[key] = this.props.comment[key]
        );
        this.handleChangeComents = this.handleChangeComents.bind(this);
        this.handleChangeComent = this.handleChangeComent.bind(this);
        this.getComentDate = this.getComentDate.bind(this);
    }
    render() {
        const { documentId, parentCommentId, statuses, nesting } = this.props;
        const { id, userFullName, position, created, content, userName, commentBeanList, initiatorSystem, show, files, telephone, editComment, newComment, removedComment } = this.state;
        const email = this.context.email;
        const leftPadding = nesting === 1 ? 50 : Math.round(50 * Math.pow(0.85, nesting));
        let btns = removedComment ? [
            {
                onClick: () => showModalDialog('modalDialog', i18next.t("addComment"), "", <CommentForm withFiles={true} handleChangeComment={this.replyComent.bind(this)} onCloseHandler={() => { hideModalDialog('modalDialog'); }} />, "feedPopup"),
                svg: { src: "/img/comment-icn-reply.svg" }, className: "btn btn-primary"
            },
            {
                onClick: () => { this.setState({ show: !show }) },
                text: commentBeanList?.length ? i18next.t("18", { value: commentBeanList.length }) : '', className: "btn btn-secondary"
            }
        ] : [
            {
                onClick: () => showModalDialog('modalDialog', i18next.t("deleteCommentMessage"), "", i18next.t(""), "feedPopup", true, [{ title: i18next.t("yes"), clickHandler: this.props.handleDeliteComent, class: "btn-primary" }, { title: i18next.t("no"), clickHandler: () => hideModalDialog('modalDialog'), class: "btn-secondary" }]),
                svg: { src: "/img/comment-icn-trash.svg" }, forAuthor: true
            },
            {
                onClick: () => showModalDialog('modalDialog', i18next.t("editComment"), "", <CommentForm withFiles={true} files={files} handleChangeComment={this.editComent.bind(this)} onCloseHandler={() => { hideModalDialog('modalDialog'); }} comment={this.state} />, "feedPopup"),
                svg: { src: "/img/comment-icn-edit.svg" }, forAuthor: true
            },
            {
                onClick: () => showModalDialog('modalDialog', i18next.t("addComment"), "", <CommentForm withFiles={true} handleChangeComment={this.replyComent.bind(this)} onCloseHandler={() => { hideModalDialog('modalDialog'); }} />, "feedPopup"),
                svg: { src: "/img/comment-icn-reply.svg" }, className: "btn btn-primary"
            },
            {
                onClick: () => { this.setState({ show: !show }) },
                text: commentBeanList?.length ? i18next.t("18", { value: commentBeanList.length }) : '', className: "btn btn-secondary"
            }
        ];
        return (
            <div id={id} className="comment-block">
                <div className="comment">
                    <div className="comment-header">
                        <div className="comment-header-info">
                            <div className="comment-main-info">
                                {initiatorSystem !== constants.initiatorSystem.PORTAL && initiatorSystem ? `${statuses?.find((item) => item?.value === initiatorSystem)?.label},` : ""} {userFullName}, {position ? position : ""}
                                {telephone && ","}
                                &nbsp;
                                {telephone && <a href={"tel:" + telephone}>{telephone}</a>}
                            </div>
                            <div className="comment-date-info">
                                {documentId ? created : this.getComentDate(created)}
                                &nbsp;
                                {editComment && <span className="comment-edit-info">({editComment})</span>}
                            </div>
                        </div>
                        <div className="action">
                            {btns.map((item, index) => <button key={index} type="button" style={item.forAuthor ? { display: ((email === userName || !documentId) ? "" : "none") } : {}}
                                className={!item.className ? "btn btn-secondary" : item.className} onClick={item.onClick}>
                                {item.svg ? < Svg src={item.svg.src ?? ''} /> : ''}{item.text ? item.text : ''}
                            </button>)}
                        </div>
                    </div>
                    {newComment ?
                        <RichTextEditor content={decodeHTMLEntities(content)} disabled={true} /> :
                        <div className="comment-text">{decodeHTMLEntities(content)}</div>
                    }
                    {files && files.length > 0 &&
                        <div className="comment-attachments-list">
                            {files.map((file) =>
                                <div className="comment-attachments-item" title={file.fileName} onClick={() => this.fileLinkClicked(file)}>
                                    <div>
                                        {file.fileName}
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                </div>
                {show === true ? <div className="comments" style={{ paddingLeft: `${leftPadding}px` }} >
                    {commentBeanList?.map((item) =>
                        <Comment key={item.id} nesting={nesting + 1} statuses={statuses} parentCommentId={`${(parentCommentId ? `${parentCommentId}|` : "")}${id}`} handleDeliteComent={() => this.deleteComent.bind(this)(item)} handleChangeComents={this.handleChangeComents} handleChangeComent={this.handleChangeComent} documentId={documentId} comment={item} />
                    )}
                </div> : ''}
            </div>
        );
    }
    fileLinkClicked(file) {
        if (file) {
            if (file.fileNodeRef) {
                let fileName = file.fileName ?? '';
                if (fileName) {
                    let parts = fileName.split('.');
                    if (parts.length > 1) {
                        parts.pop();
                        fileName = parts.join('.');
                    }
                }
                downloadFile(file.fileNodeRef, fileName);
            }
            else if (file.file) {
                let objectUrl = window.URL.createObjectURL(file.file);
                let anchor = document.createElement("a");
                anchor.href = objectUrl;
                anchor.download = file.file.name;
                anchor.click();
                window.URL.revokeObjectURL(objectUrl);
            }
        }
    }
    async deleteComent(coment) {
        const { documentId, parentCommentId } = this.props;
        const { id } = this.state;
        if (documentId) {
            const data = await removeCommentAction(coment, documentId, parentCommentId ? `${parentCommentId}|${id}` : id);
            if (data) {
                this.setState({
                    comments: data
                });
                this.handleChangeComents(data);
            }
        }
        else {
            let index = this.state.commentBeanList.indexOf(coment);
            if (index !== -1) {
                this.state.commentBeanList.splice(index, 1);
                this.setState({ commentBeanList: this.state.commentBeanList });
            }
            this.handleChangeComents();
        }
        hideModalDialog('modalDialog');
    }
    async editComent(comment) {
        const { documentId, parentCommentId } = this.props;
        const { id, content, userName, files, removedFiles } = comment;
        if (documentId)
            this.buildCommentAction.bind(this)('POST', 'comments/edit', {
                parentCommentPath: `${(parentCommentId ? `${parentCommentId}|` : "")}${id}`,
                content: content,
                documentNodeRef: documentId,
                userName: userName,
                files: files,
                removedFiles: removedFiles
            });
        else {
            this.setState({
                content: content,
                files: files
            }, () => this.handleChangeComent(comment));
        }
        hideModalDialog('modalDialog');
    }
    async replyComent(subComment) {
        const { documentId, parentCommentId } = this.props;
        const { id } = this.state;
        if (documentId)
            this.buildCommentAction.bind(this)('POST', 'comments/replay', {
                parentCommentPath: `${(parentCommentId ? `${parentCommentId}|` : "")}${id}`,
                content: subComment.content,
                documentNodeRef: documentId,
                files: subComment.files
            });
        else {
            const commentBeanList = [...this.state.commentBeanList, subComment];
            this.setState({ commentBeanList: commentBeanList }, () => this.handleChangeComent(this.state));
        }
        hideModalDialog('modalDialog');
    }
    async buildCommentAction(method, url, body) {
        const response = await fetch(url, {
            method: method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        if (!response.ok) return require('../ModalDialogsTemplates').unknownErrorMessageDialog();
        const data = await response.json();
        this.handleChangeComents(data);
    }
    handleChangeComents(comnets) {
        this.props.handleChangeComents(comnets);
        hideModalDialog('modalDialog');
    }
    handleChangeComent(comnet) {
        const { commentBeanList } = this.state;
        const index = commentBeanList.findIndex((item) => item.id === comnet.id);
        if (index !== -1) commentBeanList[index] = comnet;
        if (this.props.handleChangeComent) 
            this.props.handleChangeComent(this.state);
    }
    getComentDate() {
        const { created } = this.state;
        const date = new Date(created);
        return `${date.toLocaleDateString("uk-UA")} ${date.toLocaleTimeString("uk-UA").substring(0, 5)}`;
    }
}